(() => {
  'use strict';
  const configurator = document.querySelector('[data-dm-configurator]');
  if (!configurator) return;
  const configNode = document.getElementById('dm-ux-config');
  let labels = {};
  try { labels = JSON.parse(configNode?.textContent || '{}'); } catch (_) {}
  const text = (key, values = {}) => Object.entries(values).reduce((copy, [name, value]) => copy.split(`{${name}}`).join(String(value)), labels[key] || key);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = value => `${new Intl.NumberFormat('en-CA', {style:'currency', currency:'CAD', maximumFractionDigits:2}).format(value)} CAD`;
  const storageKey = 'date-me-box-builder-v3';
  const packagingVariant = 48827467399413;
  const boxes = [...configurator.querySelectorAll('[data-dm-box-size]')];
  const sourceGrid = document.querySelector('.collection-wrapper');
  const flavours = [...document.querySelectorAll('[data-dm-flavour-picker]')].map(picker => {
    const card = picker.closest('product-card, .product-grid__item');
    const image = card?.querySelector('img');
    return {title:picker.dataset.title, description:picker.dataset.description || card?.querySelector('.dm-card-note')?.textContent?.trim() || '', src:image?.currentSrc || image?.src || ''};
  }).filter((item, index, list) => item.title && list.findIndex(other => other.title === item.title) === index);
  const state = {size:0, price:0, variant:0, packaging:'classic', flavours:new Map(), giftMessage:''};
  let activeSheet = null;
  let returnFocus = null;
  let adding = false;
  const inertState = new Map();
  const count = () => [...state.flavours.values()].reduce((total, qty) => total + qty, 0);
  const subtotal = () => state.price + (state.size === 9 && state.packaging === 'signature' ? 5 : 0);
  const summary = () => [...state.flavours].map(([title, qty]) => `${title} ×${qty}`).join(' · ');
  function save() {
    try { localStorage.setItem(storageKey, JSON.stringify({...state, boxVariant:state.variant, flavours:[...state.flavours]})); } catch (_) {}
  }
  function chooseBox(button, open = true) {
    document.dispatchEvent(new CustomEvent('dm:builder-closed'));
    state.size = Number(button.dataset.dmBoxSize);
    state.price = Number(button.dataset.dmBoxPrice);
    state.variant = Number(button.dataset.dmBoxVariant);
    state.packaging = 'classic';
    state.flavours.clear();
    state.giftMessage = '';
    update();
    save();
    if (open) show(flavourSheet);
  }
  function assortment() {
    if (!state.size || !flavours.length) return;
    document.dispatchEvent(new CustomEvent('dm:builder-closed'));
    state.flavours.clear();
    for (let i = 0; i < state.size; i++) {
      const title = flavours[i % flavours.length].title;
      state.flavours.set(title, (state.flavours.get(title) || 0) + 1);
    }
    update();
    save();
  }
  function createSheet(className, html) {
    const sheet = document.createElement('div');
    sheet.className = className;
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML = html;
    document.body.append(sheet);
    return sheet;
  }
  function show(sheet) {
    if (!state.size || adding) return;
    if (sheet === packagingSheet && count() !== state.size) return;
    const from = activeSheet;
    if (!from) returnFocus = document.activeElement;
    if (from) {
      document.dispatchEvent(new CustomEvent('dm:builder-closed'));
      from.hidden = true;
      from.classList.remove('is-open');
      from.setAttribute('aria-hidden', 'true');
    }
    if (!inertState.size) [...document.body.children].forEach(el => inertState.set(el, el.inert));
    [...document.body.children].forEach(el => { el.inert = el !== sheet; });
    activeSheet = sheet;
    sheet.inert = false;
    sheet.hidden = false;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dm-no-scroll');
    update();
    sheet.querySelector('[data-dm-dialog-heading]')?.focus();
  }
  function close() {
    if (!activeSheet || adding) return;
    activeSheet.hidden = true;
    activeSheet.classList.remove('is-open');
    activeSheet.setAttribute('aria-hidden', 'true');
    activeSheet = null;
    inertState.forEach((value, el) => { el.inert = value; });
    inertState.clear();
    document.body.classList.remove('dm-no-scroll');
    document.dispatchEvent(new CustomEvent('dm:builder-closed'));
    if (returnFocus?.isConnected && returnFocus !== document.body) returnFocus.focus({preventScroll:true});
    else boxes.find(button => Number(button.dataset.dmBoxSize) === state.size)?.focus({preventScroll:true});
  }
  const flavourSheet = createSheet('dm-flavour-sheet', `
    <button class="dm-flavour-sheet__backdrop" type="button" data-dm-close aria-label="${escape(text('close_flavours'))}" tabindex="-1"></button>
    <section class="dm-flavour-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="dm-flavour-sheet-title" aria-describedby="dm-flavour-start-hint">
      <header class="dm-flavour-sheet__header">
        <div><div class="dm-configurator__eyebrow">${escape(text('step_flavours'))}</div><h2 id="dm-flavour-sheet-title" tabindex="-1" data-dm-dialog-heading>${escape(text('choose_flavours'))}</h2><p data-dm-progress role="status"></p></div>
        <div class="dm-box-preview" data-dm-box-preview><div class="dm-box-preview__label"><span data-dm-preview-label>${escape(text('empty_box'))}</span><span data-dm-preview-count></span></div><div class="dm-box-preview__slots" data-dm-preview-slots aria-hidden="true"></div><button class="dm-builder-motion-toggle" type="button" data-dm-builder-motion data-pause-label="${escape(text('pause_motion'))}" data-resume-label="${escape(text('resume_motion'))}" hidden>${escape(text('pause_motion'))}</button></div>
        <button class="dm-flavour-sheet__close" type="button" data-dm-close aria-label="${escape(text('close'))}">×</button>
        <div class="dm-flavour-sheet__progress" aria-hidden="true"><span data-dm-progress-fill></span></div>
      </header>
      <div class="dm-flavour-sheet__tools"><p id="dm-flavour-start-hint">${escape(text('flavour_instructions'))}</p><div class="dm-flavour-sheet__toolbar-actions"><button type="button" class="dm-surprise-button" data-dm-assortment>${escape(text('assorted_mix'))}</button><button type="button" class="dm-surprise-button dm-surprise-button--secondary" data-dm-reset>${escape(text('reset'))}</button></div></div>
      <div class="dm-flavour-sheet__body"><p class="dm-ux-allergen">${escape(text('allergen_notice'))}</p><div class="dm-flavour-choices"></div></div>
      <footer class="dm-flavour-sheet__footer"><div class="dm-flavour-sheet__footer-copy"><strong data-dm-flavour-total></strong><span data-dm-mix-summary></span></div><button type="button" class="dm-flavour-sheet__continue" data-dm-continue disabled></button></footer>
    </section>`);
  const grid = flavourSheet.querySelector('.dm-flavour-choices');
  flavours.forEach(item => {
    const article = document.createElement('article');
    article.className = 'dm-flavour-choice';
    article.dataset.dmChoiceTitle = item.title;
    article.innerHTML = `
      <div class="dm-flavour-choice__media">${item.src ? `<img src="${escape(item.src)}" alt="${escape(item.title)}" loading="lazy" width="96" height="96">` : ''}</div>
      <div class="dm-flavour-choice__copy"><strong>${escape(item.title)}</strong></div>
      <div class="dm-flavour-choice__controls" aria-label="${escape(text('choose_title', {title:item.title}))}"><button type="button" data-dm-minus aria-label="${escape(text('remove_one', {title:item.title}))}">−</button><span data-dm-count>0</span><button type="button" data-dm-plus aria-label="${escape(text('add_one', {title:item.title}))}">+</button></div>
      <details class="dm-flavour-details"><summary>${escape(text('flavour_details'))}</summary><p>${escape(item.description || text('flavour_missing'))}</p><a href="mailto:datemeorders@gmail.com">${escape(text('email_us'))}</a></details>`;
    grid.append(article);
  });
  if (sourceGrid) {
    sourceGrid.hidden = true;
    sourceGrid.inert = true;
    sourceGrid.classList.add('dm-flavour-source-grid');
  }
  const signatureImage = configurator.dataset.signatureImage || '';
  const classicImage = configurator.dataset.classicImage || '';
  const packagingSheet = createSheet('dm-packaging-sheet', `
    <button class="dm-packaging-sheet__backdrop" type="button" data-dm-close aria-label="${escape(text('close_packaging'))}" tabindex="-1"></button>
    <section class="dm-packaging-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="dm-packaging-title">
      <button class="dm-packaging-sheet__close" type="button" data-dm-close aria-label="${escape(text('close'))}">×</button>
      <div class="dm-configurator__eyebrow">${escape(text('step_packaging'))}</div>
      <h2 id="dm-packaging-title" tabindex="-1" data-dm-dialog-heading>${escape(text('packaging_title'))}</h2>
      <p class="dm-packaging-sheet__lede" data-dm-packaging-lede></p>
      <div class="dm-packaging-options">
        <button type="button" class="dm-packaging-option" data-dm-packaging="classic" aria-pressed="true">${classicImage ? `<span class="dm-packaging-option__visual"><img src="${escape(classicImage)}" alt="${escape(text('classic'))}" width="96" height="96"></span>` : ''}<span class="dm-packaging-option__content"><strong>${escape(text('classic'))}</strong><small>${escape(text('classic_note'))}</small></span><strong>${escape(text('included'))}</strong></button>
        <button type="button" class="dm-packaging-option" data-dm-packaging="signature" aria-pressed="false">${signatureImage ? `<span class="dm-packaging-option__visual"><img src="${escape(signatureImage)}" alt="${escape(text('signature'))}" width="96" height="96"></span>` : ''}<span class="dm-packaging-option__content"><strong>${escape(text('signature'))}</strong><small>${escape(text('signature_note'))}</small></span><strong>${escape(text('signature_extra'))}</strong></button>
      </div>
      <div class="dm-ux-review"><strong>${escape(text('your_mix'))}</strong><p data-dm-packaging-mix></p><button type="button" class="dm26-text-link" data-dm-edit>${escape(text('edit_mix'))}</button></div>
      <label class="dm-ux-gift-note">${escape(text('gift_message'))}<textarea rows="2" maxlength="200" data-dm-gift-note aria-describedby="dm-gift-hint"></textarea><small id="dm-gift-hint">${escape(text('gift_message_hint'))}</small></label>
      <details class="dm-ordering-summary"><summary>${escape(text('policy_details'))}</summary><div><p>${escape(text('delivery_summary'))}</p><p>${escape(text('pickup_summary'))}</p><p>${escape(text('timing_summary'))}</p></div></details>
      <div class="dm-packaging-summary"><span>${escape(text('subtotal'))}</span><strong data-dm-summary-total></strong></div>
      <p class="dm-ux-total-note">${escape(text('policy_tax'))}</p>
      <button class="dm-add-box" type="button" data-dm-add-box></button><p class="dm-packaging-sheet__error" data-dm-error role="alert" hidden></p>
      <p class="dm-packaging-sheet__fineprint">${escape(text('cart_fineprint'))}</p>
    </section>`);
  const bar = document.createElement('div');
  bar.className = 'dm-builder-bar';
  bar.innerHTML = `<div class="dm-builder-bar__inner"><div class="dm-builder-bar__copy"><strong data-dm-bar-title></strong><span data-dm-bar-status></span></div><div class="dm-builder-bar__track" aria-hidden="true"><span></span></div><button type="button" class="dm-builder-bar__cta" data-dm-bar-cta></button></div>`;
  document.body.append(bar);
  const preview = flavourSheet.querySelector('[data-dm-box-preview]');
  const previewSlots = flavourSheet.querySelector('[data-dm-preview-slots]');
  function updatePreview() {
    const mix = [...state.flavours].flatMap(([title, quantity]) => Array(quantity).fill(flavours.find(item => item.title === title)));
    preview.classList.toggle('is-complete', state.size > 0 && mix.length === state.size);
    flavourSheet.querySelector('[data-dm-preview-label]').textContent = text(mix.length ? 'your_mix' : 'empty_box');
    flavourSheet.querySelector('[data-dm-preview-count]').textContent = `${mix.length} / ${state.size}`;
    previewSlots.style.setProperty('--dm-preview-columns', Math.min(state.size || 9, 12));
    previewSlots.innerHTML = Array.from({length: state.size}, (_, index) => {
      const item = mix[index];
      return `<span class="dm-box-preview__slot${item ? ' is-filled' : ''}"${item ? ` data-dm-slot-title="${escape(item.title)}"` : ''}>${item?.src ? `<img src="${escape(item.src)}" alt="" width="40" height="40">` : `<i>${index + 1}</i>`}</span>`;
    }).join('');
  }
  function update() {
    const total = count();
    const remaining = Math.max(0, state.size - total);
    const full = state.size > 0 && total === state.size;
    const progress = state.size ? text(full ? 'ready' : total ? 'progress' : 'start_progress', {size:state.size, count:total, remaining}) : text('box_sizes');
    flavourSheet.classList.toggle('dm-is-empty', total === 0);
    const title = state.size ? text('box_total', {size:state.size, price:money(subtotal())}) : text('box_start');
    updatePreview();
    boxes.forEach(button => {
      const selected = Number(button.dataset.dmBoxSize) === state.size;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    configurator.querySelectorAll('[data-dm-step-indicator]').forEach(el => {
      const current = activeSheet === packagingSheet ? 3 : state.size ? 2 : 1;
      const step = Number(el.dataset.dmStepIndicator);
      el.classList.toggle('is-active', step === current);
      el.classList.toggle('is-done', step < current);
      if (step === current) el.setAttribute('aria-current','step'); else el.removeAttribute('aria-current');
    });
    document.documentElement.classList.toggle('dm-box-selected', state.size > 0);
    bar.querySelector('[data-dm-bar-title]').textContent = title;
    bar.querySelector('[data-dm-bar-status]').textContent = progress;
    const barButton = bar.querySelector('[data-dm-bar-cta]');
    barButton.disabled = !state.size;
    barButton.textContent = text(full ? 'choose_packaging' : state.size ? 'choose_flavours' : 'choose_box');
    bar.querySelector('.dm-builder-bar__track span').style.width = `${state.size ? total / state.size * 100 : 0}%`;
    flavourSheet.querySelector('[data-dm-progress]').textContent = progress;
    flavourSheet.querySelector('[data-dm-progress-fill]').style.width = `${state.size ? total / state.size * 100 : 0}%`;
    flavourSheet.querySelector('[data-dm-flavour-total]').textContent = title;
    flavourSheet.querySelector('[data-dm-mix-summary]').textContent = summary() || text('nothing_selected');
    const next = flavourSheet.querySelector('[data-dm-continue]');
    next.disabled = !full;
    next.textContent = full ? `${text('choose_packaging')} →` : text('choose_remaining', {remaining});
    flavourSheet.querySelector('[data-dm-reset]').hidden = total === 0;
    grid.querySelectorAll('[data-dm-choice-title]').forEach(choice => {
      const quantity = state.flavours.get(choice.dataset.dmChoiceTitle) || 0;
      choice.classList.toggle('is-selected', quantity > 0);
      choice.querySelector('[data-dm-count]').textContent = quantity;
      choice.querySelector('[data-dm-minus]').disabled = quantity === 0;
      choice.querySelector('[data-dm-plus]').disabled = full;
    });
    const signature = packagingSheet.querySelector('[data-dm-packaging="signature"]');
    signature.hidden = state.size !== 9;
    packagingSheet.querySelector('[data-dm-packaging-lede]').textContent = text(state.size === 9 ? 'packaging_intro' : 'packaging_classic_only');
    packagingSheet.querySelectorAll('[data-dm-packaging]').forEach(button => {
      const selected = button.dataset.dmPackaging === state.packaging;
      button.classList.toggle('is-selected',selected);
      button.setAttribute('aria-pressed',String(selected));
    });
    packagingSheet.querySelector('[data-dm-packaging-mix]').textContent = summary();
    packagingSheet.querySelector('[data-dm-summary-total]').textContent = money(subtotal());
    const addButton = packagingSheet.querySelector('[data-dm-add-box]');
    if (!adding) addButton.textContent = text('add_cart',{price:money(subtotal())});
    const note = packagingSheet.querySelector('[data-dm-gift-note]');
    if (note !== document.activeElement) note.value = state.giftMessage;
    document.documentElement.style.setProperty('--dm-builder-bar-height',`${bar.offsetHeight}px`);
  }
  async function addBox() {
    if (adding || !state.variant || count() !== state.size) return;
    adding = true;
    const button = packagingSheet.querySelector('[data-dm-add-box]');
    const error = packagingSheet.querySelector('[data-dm-error]');
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    button.textContent = text('adding');
    error.hidden = true;
    const properties = {'Box size':`${state.size} dates`, 'Flavours':[...state.flavours].map(([title, qty])=>`${title} ×${qty}`).join(', '), 'Packaging':state.packaging === 'signature' ? 'Signature Gift Box' : 'Classic Box'};
    if (state.giftMessage.trim()) properties['Gift message'] = state.giftMessage.trim();
    const items = [{id:state.variant,quantity:1,properties}];
    if (state.size === 9 && state.packaging === 'signature') items.push({id:packagingVariant,quantity:1});
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart/add.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const payload = await response.json().catch(()=>null);
      if (!response.ok) throw new Error(payload?.description || payload?.message || text('cart_retry'));
      button.textContent = text('added');
      try { localStorage.removeItem(storageKey); } catch (_) {}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      location.assign(`${root}cart`);
    } catch (reason) {
      adding = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      error.hidden = false;
      error.textContent = text('cart_error',{message:reason.message || text('cart_retry')});
      update();
    }
  }
  const mainSection = configurator.closest('.shopify-section');
  if (mainSection?.previousElementSibling?.classList.contains('shopify-section')) mainSection.previousElementSibling.classList.add('dm-builder-heading-hidden');
  update();
  document.addEventListener('click',event => {
    const target = event.target.closest('button');
    if (!target || adding) return;
    if (target.matches('[data-dm-box-size]')) { chooseBox(target); return; }
    if (target.matches('[data-dm-close]')) { close(); return; }
    if (target.matches('[data-dm-plus], [data-dm-minus]')) {
      if (target.disabled) return;
      const increment = target.matches('[data-dm-plus]');
      const before = count();
      const title = target.closest('[data-dm-choice-title]').dataset.dmChoiceTitle;
      const next = (state.flavours.get(title) || 0) + (increment ? 1 : -1);
      if (next < 0 || next > state.size || (increment && before >= state.size)) return;
      if (next) state.flavours.set(title,next); else state.flavours.delete(title);
      update();save();
      if (increment) {
        const destination = [...previewSlots.children].filter(slot => slot.dataset.dmSlotTitle === title).at(-1);
        document.dispatchEvent(new CustomEvent('dm:flavour-added', {detail:{source:target.closest('[data-dm-choice-title]').querySelector('img'), destination, preview, complete:before < state.size && count() === state.size}}));
      }
      return;
    }
    if (target.matches('[data-dm-assortment]')) { assortment();return; }
    if (target.matches('[data-dm-reset]')) { state.flavours.clear();update();save();return; }
    if (target.matches('[data-dm-continue]')) { show(packagingSheet);return; }
    if (target.matches('[data-dm-edit]')) { show(flavourSheet);return; }
    if (target.matches('[data-dm-bar-cta]')) { show(count() === state.size ? packagingSheet : flavourSheet);return; }
    if (target.matches('[data-dm-packaging]')) {
      if (target.dataset.dmPackaging === 'signature' && state.size !== 9) return;
      state.packaging = target.dataset.dmPackaging;update();save();return;
    }
    if (target.matches('[data-dm-add-box]')) addBox();
  });
  packagingSheet.querySelector('[data-dm-gift-note]').addEventListener('input',event => {state.giftMessage = event.target.value.slice(0,200);save();});
  document.addEventListener('keydown',event => {
    if (!activeSheet) return;
    if (event.key === 'Escape') { event.preventDefault();close();return; }
    if (event.key !== 'Tab') return;
    const focusable = [...activeSheet.querySelectorAll('button:not(:disabled), a[href], summary, textarea')].filter(el => el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[hidden]'));
    const first = focusable[0], last = focusable.at(-1);
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) {event.preventDefault();first.focus();}
  });
  const params = new URLSearchParams(location.search);
  const requested = boxes.find(item => Number(item.dataset.dmBoxSize) === Number(params.get('box')));
  if (requested) {
    chooseBox(requested,false);
    if (params.get('packaging') === 'signature' && state.size === 9) state.packaging = 'signature';
    update();save();
    show(flavourSheet);
  }
})();
